module.exports = __webpack_public_path__ + "media/images/miscellaneous_icons/fb-icon-solid-c1a025d5bcba6ebd1de41f9737f96a80.png";